import {
    Table, TableBody, TableCell, TableContainer, TableHead,
    TableRow, Paper, TextField, Typography
} from '@mui/material';
import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateSumInsuredSectionData, selectEndorsmentFormData } from 'src/features/rfqDataSlice';
import request from 'src/utils/request'; // make sure the path is correct

function SumInsuredLabelvaluepairEditable({ policyDetails }) {
    const dispatch = useDispatch();
    const endorsementFormData = useSelector(selectEndorsmentFormData);
    const selectedItems = endorsementFormData?.sumInsuredSectionData?.[policyDetails.id]?.labelValuePairItem || [];

    const [rows, setRows] = useState([]);
    const originalRowsRef = useRef(null);

    useEffect(() => {
        if (policyDetails?.policyId) {
            getSavedLabelValueDatas();
        }
    }, [policyDetails]);

    const getSavedLabelValueDatas = async () => {
        request({
            url: 'insurancePolicy/getSumInsuredList',
            method: 'post',
            data: {
                policyId: policyDetails.policyId,
                sectionId: policyDetails.id,
                listType: 'labelValuePair',
            }
        }).then(
            (response) => {
                const result = response.data.map((labelValueData) => ({
                    description: labelValueData?.description,
                    sumInsured: labelValueData?.sumInsured,
                    id: labelValueData?.id,
                    savedStatus: true,
                    isSuminsured: labelValueData?.isSuminsured
                }));

                setRows(result);

                if (!originalRowsRef.current) {
                    originalRowsRef.current = JSON.parse(JSON.stringify(result)); // lock old values once
                }

                document.getElementById('sumInsuredBox')?.style?.setProperty('display', 'block');
            },
            (error) => {
                console.log(error);
            }
        );
    };

    const isRowEditable = (rowId) => {
        return selectedItems.some(item => item.id === rowId);
    };

    const handleChange = (id, key, value) => {
        const updatedRows = rows.map(row =>
            row.id === id ? { ...row, [key]: value } : row
        );
        setRows(updatedRows);

        const updatedSelectedRows = updatedRows.filter(row =>
            selectedItems.some(item => item.id === row.id)
        );

        dispatch(updateSumInsuredSectionData({
            sumInsuredSectionData: {
                [policyDetails.id]: {
                    sectionType: 'labelValuePair',
                    groups: [],
                    labelValuePairItem: updatedSelectedRows
                }
            }
        }));
    };

    return (
        <TableContainer component={Paper} sx={{ maxHeight: '500px', overflowY: 'auto', mt: 1, boxShadow: 'unset' }}>
            <Table size="small" style={{ margin: '10px 0' }}>
                <TableHead>
                    {policyDetails?.sectionName && (
                        <TableRow>
                            <TableCell
                                colSpan={3}
                                style={{
                                    fontWeight: 'bold',
                                    textAlign: 'left',
                                    background: 'rgb(9 84 174)',
                                    color: '#fff',
                                    paddingTop: '2px',
                                    paddingBottom: '2px'
                                }}
                            >
                                {policyDetails?.sectionName}
                            </TableCell>
                        </TableRow>
                    )}
                    <TableRow>
                        <TableCell style={{ width: '470px', paddingLeft: '0px' }}>
                            {policyDetails?.sumInsuredHeaderSorted?.labelText}
                        </TableCell>
                        <TableCell style={{width:'450px'}} align="left"><strong>Old Value</strong></TableCell>
                        <TableCell align="left"><strong>New Value</strong></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {rows.map((row, rowIndex) => {
                        const original = originalRowsRef.current?.find(r => r.id === row.id);
                        const isEditable = isRowEditable(row.id);

                        return (
                            <TableRow key={rowIndex}>
                                {/* Column 1: Description */}
                                <TableCell style={{ paddingLeft: '0px' }}>
                                    <Typography>{row.description || '------------------------'}</Typography>
                                </TableCell>

                                {/* Column 2: Old Value */}
                                <TableCell align="left">
                                    <Typography>{original?.sumInsured ?? row.sumInsured ?? '—'}</Typography>
                                </TableCell>

                                {/* Column 3: New Value */}
                                <TableCell align="left">
                                    {isEditable ? (
                                        <TextField
                                            size="small"
                                            variant="outlined"
                                            fullWidth
                                            value={row.sumInsured}
                                            onChange={(e) => handleChange(row.id, 'sumInsured', e.target.value)}
                                        />
                                    ) : (
                                        <Typography>{row.sumInsured}</Typography>
                                    )}
                                </TableCell>
                            </TableRow>
                        );
                    })}
                </TableBody>
            </Table>
        </TableContainer>
    );
}

export default SumInsuredLabelvaluepairEditable;
